import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { refreshAccessToken } from "../../../Redux/LoginRedux";
import { processQueue, setIsRefreshing } from "./SessionDialougeTrigger";
import ConfirmationDialog from "../../Dashboard/ConfirmationDialog";
import { useNavigate } from "react-router-dom";

function RefreshDialogBox({ onClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [confirmationType, setConfirmationType] = useState("expiry");
  useEffect(() => {
    const refreshToken = sessionStorage.getItem("refreshToken");

    dispatch(refreshAccessToken(refreshToken))
      .then((response) => {
        sessionStorage.setItem("accessToken", response.accessToken);
        sessionStorage.setItem("refreshToken", response.refreshToken);
        processQueue(null, response.accessToken);
        setIsRefreshing(false);
        onClose();
      })
      .catch((err) => {
        if (err.message == "Failed to refresh token") {
          setOpen(true);
        }
        processQueue(err, null);
        setIsRefreshing(false);
      });
  }, [dispatch, onClose]);

  const handleSubmit = () => {
    sessionStorage.clear();
    localStorage.clear();
    setOpen(false);
    navigate('/account  ')
  }

  return (<>
    {open && (
      <ConfirmationDialog
        open={open}
        onClose={onClose}
        onConfirm={
          confirmationType === "expiry" && handleSubmit
        }
        description={
          confirmationType === "expiry"
          && "Token expired. Please login again"
        }
      />)}</>
  );

}

export default RefreshDialogBox;
